import React, { useState } from 'react';
import {
  FaFolder,
  FaRegFileAlt,
  FaChevronDown,
  FaChevronRight,
} from 'react-icons/fa';

const VariableTree = ({ data, onSelect, isDark }) => {
  const [openNodes, setOpenNodes] = useState({});

  const handleToggle = (id) => {
    setOpenNodes((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const renderTree = (nodes, level = 0) => {
    if (!Array.isArray(nodes)) return null;
    return nodes.map((node, idx) => {
      const isLeaf = !node.children || node.children.length === 0;
      const indent = 18 * level;
      return (
        <div key={node.id || idx} style={{ marginBottom: 2 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: indent,
              color: isDark === 'true' ? '#fff' : '#333',
              fontWeight: isLeaf ? 400 : 600,
              cursor:
                isLeaf && node.value
                  ? 'pointer'
                  : !isLeaf
                  ? 'pointer'
                  : 'default',
              userSelect: 'none',
              borderRadius: 5,
              transition: 'background 0.2s',
            }}
            onClick={
              isLeaf && node.value
                ? () => onSelect(node.value)
                : !isLeaf
                ? () => handleToggle(node.id)
                : undefined
            }
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                isDark === 'true' ? '#263238' : '#e0e0e0';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
            }}
          >
            {!isLeaf && (
              <span style={{ marginRight: 6 }}>
                {openNodes[node.id] ? (
                  <FaChevronDown size={13} />
                ) : (
                  <FaChevronRight size={13} />
                )}
              </span>
            )}
            {isLeaf ? (
              <FaRegFileAlt style={{ marginRight: 7, opacity: 0.7 }} />
            ) : (
              <FaFolder style={{ marginRight: 7, opacity: 0.7 }} />
            )}
            {node.label}
          </div>
          {!isLeaf && openNodes[node.id] && (
            <div>{renderTree(node.children, level + 1)}</div>
          )}
        </div>
      );
    });
  };

  return (
    <div
      style={{ maxHeight: 350, minWidth: 260, overflowY: 'auto', fontSize: 15 }}
    >
      {renderTree(data)}
    </div>
  );
};

export default VariableTree;
